<template>
    <div id="app">
        <header class="header" :class="{ iframe: iframe }">
            <!-- <b-navbar>
                <b-container class="brands-container justify-content-center flex-column flex-sm-row">
                    <b-navbar-brand class="udec-brand" href="https://www.udec.cl" target="_blank">
                        <img src="@/assets/logo-udec.png" class="d-inline-block align-top" height="84" alt="Logo UDEC">
                    </b-navbar-brand>
                </b-container>
            </b-navbar> -->
            <b-container class="title-container">
                <!-- <h1 class="title">¿Quieres saber tu <strong> puntaje de postulación?</strong></h1> -->
                <!-- <img class="titulo-img titulo-img-movil" src="./assets/saber-tu-puntaje-movil.png"> -->
                <!-- <img class="titulo-img titulo-img-escritorio" src="./assets/saber-tu-puntaje-escritorio.png"> -->
                <h3 v-if="!iframe" class="busca-tu-carrera d-md-none">Busca tu carrera</h3>
                <b-row class="search-wrapper justify-content-center">
                    <b-col sm="12" lg="9">
                        <div class="input-wrapper input-group d-flex">
                            <input type="search" id="search-input" v-model="searchValue" autocomplete="off" class="form-control" placeholder="Ej: Bioingeniería">
                            <div class="input-group-append d-flex align-items-center">
                                <i class="far fa-search"></i>
                            </div>
                        </div>
                        <div v-if="iframe">
                            <div v-if="searchValue" class="search-results iframe">
                                <h2 v-if="searchCareers.Concepción.length" class="campus">CAMPUS CONCEPCIÓN</h2>
                                <div class="carrera" v-for="(career, index) in searchCareers.Concepción" :id="index" :key="`${index}conce-search`">
                                    <a href="#" @click.prevent="setCurrentCareer(career, 'Concepción')" v-b-modal="'modal-formulario'">
                                        {{ career.CARRERA }}
                                    </a>
                                </div>
                                <h2 v-if="searchCareers.Chillán.length" class="campus">CAMPUS CHILLÁN</h2>
                                <div class="carrera" v-for="(career, index) in searchCareers.Chillán" :id="`${index}-chillan`" :key="`${index}chillan-search`">
                                    <a href="#" @click.prevent="setCurrentCareer(career, 'Chillán')" v-b-modal="'modal-formulario'">
                                        {{ career.CARRERA }}
                                    </a>
                                </div>
                                <h2 v-if="searchCareers['Los Angeles'].length" class="campus">CAMPUS LOS ANGELES</h2>
                                <div class="carrera" v-for="(career, index) in searchCareers['Los Angeles']" :id="`${index}-los-angeles`" :key="`${index}la-search`">
                                    <a href="#" @click.prevent="setCurrentCareer(career, 'Los Angeles')" v-b-modal="'modal-formulario'">
                                        {{ career.CARRERA }}
                                    </a>
                                </div>
                            </div>
                        </div>
                            
                    </b-col>
                </b-row>
                <h3 v-if="!iframe" class="busca-tu-carrera d-none d-md-block">Busca tu carrera para saber el puntaje de postulación</h3>
            </b-container>
        </header>
        <b-container v-if="!iframe" class="main-container" tag="main">
            <b-col sm="12" class="mb-36px careers-wrapper">
                <div class="row title-wrapper">
                    <b-col sm="12" lg="5" class="form-title">CARRERAS</b-col>
                    
                </div>
                <h2 v-if="searchCareers.Concepción.length" class="campus">CAMPUS CONCEPCIÓN</h2>
                <b-col md="12" class="careers">
                    <b-row class="carrera" v-for="(career, index) in searchCareers.Concepción" :id="index" :key="index">
                        <a href="#" @click.prevent="setCurrentCareer(career, 'Concepción')" v-b-modal="'modal-formulario'">
                            {{ career.CARRERA }}
                        </a>
                        <button class="btn calc-btn d-none d-md-block" @click="setCurrentCareer(career, 'Concepción')" v-b-modal="'modal-formulario'">CALCULAR</button>
                    </b-row>
                </b-col>
                <h2 v-if="searchCareers.Chillán.length" class="campus">CAMPUS CHILLÁN</h2>
                <b-col md="12" class="careers">
                    <b-row class="carrera" v-for="(career, index) in searchCareers.Chillán" :id="`${index}-chillan`" :key="index">
                        <a href="#" @click.prevent="setCurrentCareer(career, 'Chillán')" v-b-modal="'modal-formulario'">
                            {{ career.CARRERA }}
                        </a>
                        <button class="btn calc-btn d-none d-md-block" @click="setCurrentCareer(career, 'Chillán')" v-b-modal="'modal-formulario'">CALCULAR</button>
                    </b-row>
                </b-col>
                <h2 v-if="searchCareers['Los Angeles'].length" class="campus">CAMPUS LOS ÁNGELES</h2>
                <b-col md="12" class="careers">
                    <b-row class="carrera" v-for="(career, index) in searchCareers['Los Angeles']" :id="`${index}-los-angeles`" :key="index">
                        <a href="#" @click.prevent="setCurrentCareer(career, 'Los Angeles')" v-b-modal="'modal-formulario'">
                            {{ career.CARRERA }}
                        </a>
                        <button class="btn calc-btn d-none d-md-block" @click="setCurrentCareer(career, 'Los Angeles')" v-b-modal="'modal-formulario'">CALCULAR</button>
                    </b-row>
                </b-col>
            </b-col>

        </b-container>
        <footer v-if="!iframe" class="footer"
                tag="footer">
            <b-container>
                <div class="logos-container mx-auto d-flex justify-content-around">
                    <a href="https://www.biobiochile.cl">
                        <img src="@/assets/logo-bbcl.png" height="30" alt="Logo BBCL">
                    </a>
                    <a href="https://www.udec.cl">
                        <img src="@/assets/logo-udec.png" height="32" alt="Logo UDEC">
                    </a>
                </div>
                    <hr>
                    <div class="social-container mx-auto d-flex justify-content-between">
                        <a href="https://www.facebook.com/RadioBioBio" target="_blank">
                            <i class="fab fa-facebook-f"></i>
                        </a>
                        <a href="https://twitter.com/biobio" target="_blank">
                            <i class="fab fa-twitter"></i>
                        </a>
                        <a href="https://www.instagram.com/biobiochile/" target="_blank">
                            <i class="fab fa-instagram"></i>
                        </a>
                        <a href="https://www.youtube.com/c/BioBioChile/" target="_blank">
                            <i class="fab fa-youtube"></i>
                        </a>
                    </div>
                    <hr>
                    <p class="developed-by mx-auto my-0">
                        Desarrollado por BioBioChile
                    </p>
                    <p class="developed-by mx-auto my-0">
                        Concepción, Chile.
                    </p>
            </b-container>
        </footer>
        <b-modal id="modal-formulario" @touchstart.prevent style="max-width: 780px;" ref="modal">
            <div>
            <transition mode="out-in">
                <div v-if="!calculatedScore" key="scores" class="my-modal-dialog">
                    <b-row class="modal-container">
                        <b-col sm="12" class="topper">
                            <h2>CARRERA SELECCIONADA</h2>
                            <h3 v-if="currentCareer">{{ currentCareer.CARRERA }} <span v-if="currentCareer.sede != 'Concepción'">({{ currentCareer.sede }})</span></h3>
                        </b-col>

                        <b-row class="scores-wrapper">
                            <b-col v-for="test in userScores"
                                   lg="4"
                                   class="mb-36px col-6 score"
                                   :key="test.key">
                                <div class="input-box">
                                    <b-form-group :label="test.label"
                                                  :label-for="`input-${test.key}`">
                                        <b-input-group>
                                            <b-input-group-text v-if="!userData[test.key]"
                                                                slot="prepend">Ej:</b-input-group-text>
                                            <b-form-input :id="`input-${test.key}`"
                                                          v-model.number="userData[test.key]"
                                                          :placeholder="test.placeholder"
                                                          :name="test.key"
                                                          :data-vv-as="test.label"
                                                          :value="test.value"
                                                          :ref="test.ref"
                                                          v-validate="rules[test.key]"
                                                          step="any"
                                                          type="number" />
                                        </b-input-group>
                                    </b-form-group>
                                    <p v-if="errors.has(test.key)" class="error">{{ errors.first(test.key) }}</p>
                                </div>
                            </b-col>
                            <b-col v-for="test in psuTests"
                                   lg="4"
                                   class="mb-36px col-6 score"
                                   :key="test.key">
                                <div class="input-box">
                                    <b-form-group :label="test.label"
                                                  :label-for="`input-${test.key}`">
                                        <b-input-group>
                                            <b-input-group-text v-if="!userData[test.key]"
                                                                slot="prepend">Ej:</b-input-group-text>
                                            <b-form-input :id="`input-${test.key}`"
                                                          v-model.number="userData[test.key]"
                                                          placeholder="630"
                                                          :name="test.key"
                                                          :data-vv-as="test.label"
                                                          v-validate="rules[test.key]"
                                                          type="number" />
                                        </b-input-group>
                                        <span v-if="currentCareer && !currentCareer[test.slug]" class="non-required">Prueba no requerida</span>
                                        <p v-if="errors.has(test.key)" class="error">{{ errors.first(test.key) }}</p>
                                    </b-form-group>
                                </div>
                            </b-col>
                        </b-row>
                    </b-row>
                </div>
                <div v-else-if="cargando" key="loading" class="my-modal-dialog">
                    <div class="modal-container">
                        <b-row class="justify-content-center align-items-center" style="height: 100%">
                            <b-col sm="12" style="text-align:center">
                                Calculando <i class="far fa-spinner-third fa-spin" ></i>
                            </b-col>
                        </b-row>
                    </div>
                    
                </div>
                <div v-else class="my-modal-dialog" key="result">
                    <b-row class="modal-container justify-content-center">
                        <b-col lg="6"
                               class="mb-36px col-7">
                            <h2 class="modal-title">Estarías postulando con:</h2>
                            <div class="input-box" id="total-score">
                                <b-form-group>
                                    <b-input-group>
                                        <b-form-input id="puntaje-ponderado"
                                                      v-model.number="calculatedScore"
                                                      type="number"
                                                      disabled />
                                    </b-input-group>
                                </b-form-group>
                            </div>
                        </b-col>
                        <b-col sm="12" class="puntajes-de-corte">
                            <b-row>
                                <b-col sm="12" class="topper">
                                    <h2>PUNTAJES DE CORTE AÑOS ANTERIORES:</h2>
                                    <h3 v-if="currentCareer">{{ currentCareer.CARRERA }} <span v-if="currentCareer.sede != 'Concepción'">({{ currentCareer.sede }})</span></h3>
                                </b-col>
                            </b-row>
                            <b-row class="puntajes">
                                <b-col class="col-sm-4">
                                    <div class="input-box">
                                        <b-form-group label="2019">
                                            <b-input-group>
                                                <b-form-input id="score-2019"
                                                              class="puntaje-corte"
                                                              v-model.number="currentCareer.PUNTAJE_CORTE_2019"
                                                              type="number"
                                                              disabled />
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                </b-col>
                                <b-col class="col-sm-4">
                                    <div class="input-box">
                                        <b-form-group label="2020">
                                            <b-input-group>
                                                <b-form-input id="score-2020"
                                                              class="puntaje-corte"
                                                              v-model.number="currentCareer.PUNTAJE_CORTE_2020"
                                                              type="number"
                                                              disabled />
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                </b-col>
                                <b-col class="col-sm-4">
                                    <div class="input-box">
                                        <b-form-group label="2021">
                                            <b-input-group>
                                                <b-form-input id="score-2021"
                                                              class="puntaje-corte"
                                                              v-model.number="currentCareer.PUNTAJE_CORTE_2021"
                                                              type="number"
                                                              disabled />
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>
            </transition>
            </div>
            <div v-if="!calculatedScore" slot="modal-footer" class="row">
                <b-btn class="clear-btn"
                        @click="clearAll"
                        variant="primary">LIMPIAR FORMULARIO</b-btn>
                <b-btn class="calculate-btn col"
                        @click="calculate"
                        variant="secondary"
                        :disabled="errors.any()">CALCULAR</b-btn>
            </div>
            <div v-else-if="!cargando" class="w-100" slot="modal-footer">
                <p class="float-left"></p>
                <b-btn class="calculate-btn d-block mx-auto btn-block"
                       @click="$refs.modal.hide()"
                       variant="secondary"
                       :disabled="errors.any()">¿QUIERES VER OTRA CARRERA?</b-btn>
            </div>
            <div v-else class="w-100" slot="modal-footer">
                <p class="float-left"></p>
                <b-btn class="calculate-btn d-block mx-auto btn-block"
                       variant="secondary"
                       :disabled="errors.any()">CALCULANDO</b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'
    import careers from './assets/carreras.json'
    //import groups from './assets/groups.json'

    export default {
        data() {
            return {
                userData: {
                    nem: null,
                    ranking: null,
                    language: null,
                    math: null,
                    science: null,
                    history: null
                },
                userScores: [
                    {key: 'nem', label: 'PJE. NEM', placeholder: '500', value: null, ref: 'nemInput'},
                    {key: 'ranking', label: 'RANKING', placeholder: '500', value: null, ref: 'rankInput'}
                ],
                psuTests: [
                    {key: 'math', label: 'MATEMÁTICAS', slug: 'MATEMATICA'},
                    {key: 'language', label: 'LENGUAJE', slug: 'LENGUAJE'},
                    {key: 'history', label: 'HISTORIA', slug: 'HISTORIA', rules: {
                        validator: value => value || this.userData.science,
                        min_value: 1,
                        max_value: 850
                    }},
                    {key: 'science', label: 'CIENCIAS', slug: 'CIENCIAS'},
                ],
                currentCareer: null,
                calculatedScore: null,
                searchValue: '',
                previousScrollY: 0,
                cargando: false,
                device: null,
                iframe: false
            }
        },
        watch: {
            'userData.nem': function(val) {
                if(val && val.toString().length > 3) {
                    this.userData.nem = val.toString().slice(0,3)
                }                
            },
            'userData.ranking': function(val) {
                if(val && val.toString().length > 3) {
                    this.userData.ranking = val.toString().slice(0,3)
                }                
            },
            'userData.language': function(val) {
                if(val && val.toString().length > 3) {
                    this.userData.language = val.toString().slice(0,3)
                }
            },
            'userData.math': function(val) {
                if(val && val.toString().length > 3) {
                    this.userData.math = val.toString().slice(0,3)
                }
            },
            'userData.science': function(val) {
                if(val && val.toString().length > 3) {
                    this.userData.science = val.toString().slice(0,3)
                }
            },
            'userData.history': function(val) {
                if(val && val.toString().length > 3) {
                    this.userData.history = val.toString().slice(0,3)
                }
            }
        },
        props: {
            requestUrl: {
                type: String,
                default: 'https://widgets.biobiochile.cl/udec/data-receiver.php'
            },
            allCareers : {
                type: Object,
                default: function() {
                    return careers
                }
            }
        },
        computed: {
            rules() {
                return {
                    nem: 'required|min_value:186|max_value:835',
                    ranking:'required|min_value:1|max_value:850',
                    math: 'required|min_value:1|max_value:850',
                    language: 'required|min_value:1|max_value:850',
                    history: {
                        required: !!this.currentCareer && this.calcularRequired('historia', this.currentCareer.HISTORIA, this.currentCareer.CIENCIAS),
                        min_value: 1,
                        max_value: 850
                    },
                    science: {
                        required: !!this.currentCareer && this.calcularRequired('ciencias', this.currentCareer.HISTORIA, this.currentCareer.CIENCIAS),
                        min_value: 1,
                        max_value: 850
                    },
                }
            },                
            searchCareers() {
                let conce, chillan, angeles
                let search = this.searchValue.trim()
                if (search) {
                    search  = search.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
                    conce   = this.allCareers.Concepción.filter( item => item.CARRERA.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(search))
                    chillan = this.allCareers.Chillán.filter( item => item.CARRERA.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(search))
                    angeles = this.allCareers['Los Angeles'].filter( item => item.CARRERA.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(search))

                    return {
                        "Concepción": conce,
                        "Chillán": chillan,
                        "Los Angeles": angeles
                    }
                }

                return this.allCareers
            }
        },
        methods: {
            calcularRequired: function(revisando, historia, ciencias){
                if(historia && ciencias){
                    if(this.userData.history || this.userData.science ){
                        return false
                    }
                    return true
                }else{
                    switch (revisando) {
                        case 'historia':
                            if(historia){
                                return true
                            }else{
                                return false
                            }
                        case 'ciencias':
                            if(ciencias){
                                return true
                            }else{
                                return false
                            }
                    }
                }
            },
            setCurrentCareer: function(career, sede) {
                this.calculatedScore = null
                this.currentCareer = career
                this.currentCareer.sede = sede
                /*setTimeout(function(el) {
                    //el.$refs.nemInput[0].$el.addEventListener('input', el.vuetifiedNem, false)
                }, 500, this)*/
            },
            calculate: function() {
                this.cargando = true
                this.$validator.validateAll().then(result => {

                    if(result) {
                        const userScore = this.calculateScore(
                            this.userData.nem,
                            this.userData.group,
                            this.userData.ranking,
                            this.userData.language,
                            this.userData.math,
                            this.userData.history,
                            this.userData.science,
                            this.currentCareer
                        )
                        setTimeout(function(el) {
                            el.cargando = false
                        }, 1000, this)
                        this.calculatedScore = userScore
                        this.sendApplicationData(this.currentCareer.CARRERA, this.calculatedScore)
                        
                    }
                })
            },
            calculateScore: function(nem, group, ranking, language, math, history, science, career) {
                let electiveScorePonderation

                if(career.HISTORIA && career.CIENCIAS) {
                    electiveScorePonderation = career['HISTORIA'] * Math.max(history, science)
                } else if(career.HISTORIA) {

                    if(!history) {
                        return -1
                    }

                    electiveScorePonderation = career['HISTORIA'] * history
                } else {

                    if(!science) {
                        return -1
                    }

                     electiveScorePonderation = career['CIENCIAS'] * science
                }

                return (
                    nem * career.NEM
                    + ranking * career.RANKING
                    + language * career.LENGUAJE
                    + math * career.MATEMATICA
                    + electiveScorePonderation
                ) / 100
            },
            sendApplicationData: function (career, score) {
                axios.post(this.requestUrl, {
                    carrera: career,
                    puntaje: score,
                    dispositivo: this.device,
                    origen: 'landing'
                })
            },
            setDevice() {
                 let media = window.matchMedia("only screen and (max-width: 760px)");
                 this.mediaHandler(media);
            },
            mediaHandler: function(media) {
                if (media.matches) {
                    this.device = 'mobile'
                }else {
                    this.device = 'desktop'
                }
            },
            clearAll: function() {
                this.userData.nem       = null
                this.userData.ranking   = null
                this.userData.language  = null
                this.userData.math      = null
                this.userData.history   = null
                this.userData.science   = null
                
                this.$validator.reset()
                //this.$refs.nemInput[0].$el.addEventListener('input', this.vuetifiedNem, false)
                
            }
        },        
        mounted() {
            this.setDevice()
            var queryiframe = this.$route.query.iframe
            if(queryiframe == 'itt'){
                this.iframe = true
            }
        }
    };

</script>
<style src="@/assets/bootstrap.scss" lang="scss"></style>
<style src="bootstrap-vue/dist/bootstrap-vue.css" scoped></style>
<style lang="scss">
html, body {
    height: 100%;
    overflow: hidden;
}

#app {
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}

.v {
    &-enter,
    &-leave-to {
        opacity: 0;
    }

    &-enter-active,
    &-leave-active {
        transition: opacity .300s linear;
    }
}

.header {
    background-image: url('./assets/bg-movil.png');
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
    // background-color: #193071;
    color: #fff;    

    .navbar {
        padding-top: 50px;
        padding-bottom: 20px;        
    }

    .navbar-brand {
        margin-right: 0
    }

    .brands-container {
        height: 100%;

        .bbcl-brand {
            margin-bottom: 70px;
        }
    }

    .title-container {
        .titulo-img {
            margin: 0 auto;
        }
        .titulo-img-movil {
            display: block;
            width: 324px;
            margin-bottom: 20px;
        }
        .titulo-img-escritorio {
            display: none;
        }

        .title {
            color: #FAFAFA;
            border-radius: 24px;
            font-size: 22px;
            line-height: 27px;
            font-style: italic;
            max-width: 340px;
            margin: 0 auto;
            padding: 10px 24px;
            text-align: center;
        }

        .sub-title {
            font-size: 24px;
            line-height: 29px;
            max-width: 330px;
            margin: 0 auto;
            text-align: center;
        }
        .busca-tu-carrera {
            font-size: 15px;
            line-height: 19px;
            text-align: center;
            margin-bottom: 12px;
            font-family: Montserrat;
            color: #FAFAFA;
        }
    }
}
.careers-wrapper {
    background-color: #fff;
    border-radius: 8px;
}
.careers-wrapper, .search-wrapper {
    padding-bottom: 10px;
    box-shadow: 0 2px 10px 4px rgba(0, 0, 0, 0.04);
    background-origin: padding-box;
    overflow: auto;

    .input-wrapper {
        padding: 8px 0;
        background-color: #fff;
        border-radius: 8px;
        height: 60px;
        align-items: center;
        max-width: 600px;
        margin: 0 auto 5px;

        input {
            border: none;            
            height: 35px;
            padding-left: 20px;
            font-size: 15px;
        }

        input:focus {
            box-shadow: none;
        }

        .input-group-append {
            border-left: 2px solid #7F95A7;
            padding: 0 15px;
            font-size: 20px;
            height: 35px;

            i {
                color: #002C4F;
            }
        }
    }
    .campus {
        text-align: center;
        font-size: 24px;
        line-height: 29px;
        padding: 25px 0;
        border-bottom: 1px solid #EFEFEF;
        margin-bottom: 15px;
        color: #002C4F;
    }
}
.search-wrapper {
    box-shadow: none;
}

.iframe{
    .input-wrapper{
        max-width: 300px;
        height: 50px;
    }
}

.search-results {
    z-index: 10;    
    .col-sm-12 {
        max-height: 300px;
        overflow-y: scroll;
        box-shadow: 0 2px 6px 5px rgba(0,0,0,0.11);
        background-color: #fff;
    }

    &.iframe{
        background-color: #fff;
        max-height: 217px;
        overflow-y: scroll;
        .campus{
            font-size: 18px;
            line-height: 22px;
            padding: 13px 0;
        }
    }
    
    
}
.careers, .search-results {
    .carrera {
        min-height: 55px;
        padding: 15px;
        background-color: #fff;

        a {
            font-size: 15px;
            line-height: 27px;
            color: #002C4F;
            font-weight: 500;
        }
    }
    .carrera:nth-child(odd) {
        background-color: #F0F3F6;
    }
}

.main-container {
    margin-top: -26%;

    .form-title {
        font-size: 24px;
        line-height: 30px;
        margin: 0 0 40px;
        padding: 30px 28px;
        text-align: center;
        border-bottom: solid 1px #EFEFEF;
        font-weight: 500;
        color: #002C4F;
    }



}
.footer {
    background-color: $udec-primary;
    color: #abb2b8;
    padding-bottom: 26px;
    padding-top: 26px;
    margin-top: 25px;

    hr {
        margin: 26px 0;
        border-top: 2px solid rgba(255, 255, 255, 0.26);
    }

    .logos-container {
        max-width: 420px;
    }

    .social-container {
        font-size: 25px;
        max-width: 150px;
        padding: 6px 0;

        .fab {
            color: #abb2b8;
        }
    }

    .developed-by {
        font-size: 12px;
        line-height: 18px;
        text-align: center;
    }
}
.modal-content {
    border-radius: 6px;
}

.modal-body {
    padding: 0;
    .my-modal-dialog {
        margin: 0;
        min-height: 350px;
    }
    .modal-title {
        color: #002C4F;
        font-size: 16px;
    }
    .topper {
        color: #002C4F;
        text-align: center;

        h2 {
            font-size: 18px;
            line-height: 22px;
            margin-bottom: 15px;
           
        }

        h3 {
            font-size: 15px;
            line-height: 19px;
            border: 1px solid #CCD5DD;
            border-radius: 32.5px;
            padding: 14px;
        }
    }
    .modal-container {
        background: #fff;
        margin-left: 0;
        margin-right: 0;
        padding-top: 15px;

        .scores-wrapper {
            margin: 0 8px;

            .score {
                padding: 0 10px;
            }

            .non-required {
                color: #ED831C;
                font-size: small;
            }
        }

        .input-box {
            margin-bottom: 25px;

            .form-group {
                max-width: 200px;
                margin: 0 auto;
                text-align: center;

                .form-control {
                    font-weight: 500;
                }
            }

            &#total-score {
                padding-top: 15px;

                #puntaje-ponderado {
                    color: #000;
                    margin-left: -10px;
                    margin-right: -10px;
                }
            }
        }

        .input-group {
            border-bottom: 1px solid #002c4f;
            padding: 0;
            padding-bottom: 7px;
        }

        .form-group {
            .input-group-text,
            .form-control::placeholder {
                color: rgba(0, 0, 0, 0.1);
            }

            .form-control {
                color: #000;
            }
            .col-form-label {
                font-size: 15px;
                font-weight: 500;
                padding: 0;
                margin-bottom: 12px;
                color: #002C4F;
            }

            .input-group-text {
                align-items: flex-end;
                background-color: transparent;
                border: none;
                color: rgba(0, 0, 0, 0.1);
                font-size: 14px;
                line-height: 18px;
                padding: 0;
            }

            input.form-control {
                background: transparent;
                border: none;
                color: rgba(0, 0, 0, 0.6);
                font-size: 38px;
                line-height: 45px;
                text-align: center;
                padding: 0;

                &::placeholder {
                    color: rgba(0, 0, 0, 0.1);
                }

                &.puntaje-corte {
                    font-size: 29px;
                    margin-left: -10px;
                    margin-right: -10px;
                }
            }

            .input-group-prepend {
                text-align: left;
            }
        }

        .puntajes-de-corte {
            
            .puntajes {
                margin: 0 -6px;
                margin-top: 10px;
                margin-bottom: 25px;

                .col {
                    padding: 0 9px;
                }
            }

            .topper {
                h2 {
                    padding-top: 15px;
                    border-top: 1px solid #EFEFEF;
                }
            }
        }
    }

    .calculate-container {
        .fill-text {
            font-size: 13px;
            line-height: 23px;

            &:first-of-type {
                margin-top: 50px;
            }

            &:last-of-type {
                margin-bottom: 50px;
            }
        }
    }
}
.modal-header {
    background-image: url('./assets/bgmodalpuntaje-movil.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    color: #fff;
    padding: 0.2rem;
    align-items: center;
    position: relative;
    min-height: 90px;

    .error {
        color: yellow;
    }

    .modal-inner-header {
        position: static;
    }

    & > div {
        width: 100%;
    }

    .col-form-label {
        font-size: 20px;
        font-style: italic;
        line-height: 24px;
        margin-bottom: 15px;
        font-weight: 500;
    }

    .close {
        // font-size: 25px;
        // color: #fff;
        // text-shadow: none;
        // opacity: 1;
        // position: absolute;
        // right: 15px; top: 10px;

        font-size: 44px;
        font-weight: 100;
        width: 30px;
        height: 30px;
        color: #fff;
        text-shadow: none;
        position: absolute;
        right: 25px;
        top: 25px;
        align-items: center;
        display: flex;
        justify-content: center;
        border-radius: 50%;
        opacity: 0.5;
        background-color: #000000;
    }

    .custom-select {
        color: #fff;
        background: rgba(255,255,255,0.2) url('./assets/chevron-arrow-down.png') no-repeat right 0.75rem center;
        background-size: 4%;
        font-size: 14px;
        height: 55px;

        option {
            color: #000;
        }
    }
}
.modal-footer {
    background-color: #fff;
    border: none;
    padding-top: 0;
    justify-content: center;

    .row {
        margin: 0;
        width: 100%;
        justify-content: space-between
    }

    .calculate-btn {
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        height: 60px;
        padding-left: 0;
        padding-right: 0;
        text-align: center;
        background-color: #3796FF !important;
        border-color: #3796FF !important;
    }
    .clear-btn {
        background-color: #002C4F;
        color: #fff;
        font-size: 11px;
        line-height: 14px;
        white-space: inherit;
        width: 85px;
        margin-right: 5px;
        padding: 0;
    }
}

@media (max-width: 575px) {
    .header {
        padding-top: 84%;
        padding-bottom: 28%;
    }
    .header.iframe{
        padding-top: 200px;
        height: 480px;
        width: 320px;
        background-image: url(./assets/bg-itt-movil.png);
        margin: auto;
    }

    .careers, .search-results {

        .carrera {
            .calc-btn {
                display: none;
            }
        }
    }

    .main-container {
        .title-wrapper {
            padding: 0 15px;
        }
    }
}

@media (min-width: 576px) {
    .header {
        /*height: 450px;*/
        background-image: url(./assets/bg-escritorio.png);
        background-size: cover;
        background-position: center;
        padding-top: 22%;
        padding-bottom: 10%;

        .navbar {
            padding: 0;

            .brands-container {
                padding: 0;
            }

            .bbcl-brand {
                margin-bottom: 0;
                img {
                    height: 31px;
                }
            }

            .udec-brand {
                padding: 50px 0;
                img {
                    height: 91px;
                }
            }
            
        }

        .title-container {

            .title {
                max-width: 655px;
                padding: 6px 24px;
                font-size: 28px;
                line-height: 34px;
                margin-bottom: 7px;
            }
            .sub-title {
                font-size: 20px;
            }

            .fill-text {
                max-width: 520px;
            }

            .busca-tu-carrera {
                margin-bottom: 0;
            }
        }
    }

    .header.iframe{
        background-image: url(./assets/bg-itt-escritorio.png);
        height: 500px;
        max-width: 900px;
        margin: 0 auto;
        padding-top: 300px;
    }

    .main-container{
        margin-top: -65px;
    }
    .iframe{
        .input-wrapper{
            max-width: 473px;
        }
    }
}

@media (min-width: 768px) {/*576*/

    

    .calculate-btn {
        max-width: 620px;
    }

    .with-triangle::after {
        bottom: -20px;
        left: calc(50% - 30px);
        border-top: 20px solid $udec-primary;
        border-left: 30px solid #fff;
        border-right: 30px solid #fff;
    }

    .search-wrapper {
        padding: 12px 130px 15px;
    }

    .careers-wrapper{
        padding: 30px 130px;

        .form-title {
            font-size: 24px;
            line-height: 29px;
            margin: 0;
            padding: 0;
            border-bottom: none;
            text-align: left;
        }
        .input-wrapper {
            padding: 8px 0;
            margin-bottom: 5px;
            height: 50px;

            input {
                height: 35px;
            }

            .input-group-append {
                height: 35px;
            }
        }

    }
    .careers, .search-results {
        .col-sm-12::-webkit-scrollbar {
            width: 5px;
        }
         
        .col-sm-12::-webkit-scrollbar-track {
            background: #ddd;
        }
         
        .col-sm-12::-webkit-scrollbar-thumb {
            background: #666; 
        }
        .carrera {
            justify-content: space-between;
            flex-wrap: nowrap;
            align-items: center;

            a {
                font-size: 14px;
                line-height: 27px;
                color: #002C4F;
                font-weight: 500;
                flex-grow: 1;
            }
            .calc-btn {
                border-radius: 22.5px;
                background-color: #3796FF;
                color: #fff;
                font-size: 14px;
                line-height: 18px;                        
                font-weight: 500;
                margin-right: 8%;
                max-height: 32px;
            }

            // &:hover .calc-btn{
            //     background-color: #d27011;
            //     color: #fff;
            // }
        }
        .carrera:nth-child(odd) {
            background-color: #F0F3F6;
        }
    }

    .main-container {
        
        .title-wrapper {
            border-bottom: 1px solid #EFEFEF;
            margin: 0;
            margin-bottom: 25px;
            padding-bottom: 30px;
        }

        .white-container {
            margin-left: -15px;
            margin-right: -15px;
        }
    }

    .footer {
        .developed-by {
            font-size: 15px;
            line-height: 24px;
        }
    }

    .my-modal-dialog {
        width: 780px;
        max-width: 780px;
    }
    .modal-dialog {
        max-width: 780px;
    }
    .modal-header {
        background-image: url('./assets/bgmodalpuntaje.png');
        padding: 20px 40px 0;
        width: 780px;
        background-position: bottom right;

        .custom-select {
            background-size: 1.5%;
            height: 55px;
            padding: 0 35px;

            option {
                color: #000;
            }
        }
    }
    .modal-body {

        .modal-title {
            font-size: 20px;
            line-height: 24px;
            text-align: center;
            color: #002C4F;
        }
    
        .topper {

            padding: 0 65px;
            color: #002C4F;

            h2 {
                font-size: 24px;
                line-height: 29px;
            }

            h3 {
                font-size: 18px;
                line-height: 18px;
                max-width: 50%;
                margin: 0 auto 15px;
                padding: 8px;
            }
        }
        .modal-container {
            .scores-wrapper {
                margin: 20px 0 0;
                padding: 0 65px;
                min-width: 100%;
                
                .score {
                    padding: 0 12px;
                }
            }

            .input-box {
                margin-bottom: 30px;

                .form-group {
                    max-width: 200px;
                    margin: 0 auto;
                    text-align: center;

                    .form-control {
                        font-weight: 500;
                    }
                }

                &#total-score {
                    
                    #puntaje-ponderado {
                        font-size: 54px;
                        line-height: 68px;
                        height: auto;
                        margin: 0 -15px;
                        text-align: center;

                    }
                }
            }

            .form-group {
                input.form-control.puntaje-corte {
                    font-size: 40px;
                    color: #000;
                    margin-bottom: 10px;
                }
            }

            .puntajes-de-corte {
        
                .puntajes {
                    padding: 0 55px;

                    .col-form-label {
                        font-size: 18px;
                        margin-bottom: 20px;
                        color: #002C4F;
                    }
                    .puntaje-corte {
                        font-size: 40px;
                    }
                }
            }

            
        }
    }

    .modal-footer {
       width: 780px;
       .row {
           padding: 0 60px;
       }
        .calculate-btn {            
            height: 50px;
            font-size: 20px;
            font-weight: 600;
            line-height: 24px;
        }
        .clear-btn {
            width: 120px;
        }


        padding-bottom: 50px;
    }
    
}

@media (min-width: 1460px) {
    .header {
        /*height: 560px;*/
    }

}

@media (min-width: 900px) {
    .header {
        .title-container {
            .titulo-img-movil {
                display: none;
            }

            .titulo-img-escritorio {
                display: block;
                width: 710px;
            }
        }
    }
}

</style>
